var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block_panel"},[_c('div',{staticClass:"b_title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"b_container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }